import { getBaseUrl } from "@/utils/generic";
import { TLangIso, TProject } from "@/types/global";

type ProjectsByIdsResponse = { projects: TProject[] };

export async function fetchProjectsByIds(
  projectsIDs: string[],
  lang: TLangIso
): Promise<TProject[]> {
  const qs = new URLSearchParams({
    "project-ids": projectsIDs.join(","),
    lang,
  });

  const res = await fetch(`${getBaseUrl()}/api/get/projects-by-ids?${qs.toString()}`);

  if (!res.ok) {
    // try to read JSON error, fallback to text
    let message = `Failed to fetch projects (${res.status})`;
    try {
      const body = await res.json();
      if (body?.message) message = body.message;
    } catch {
      // ignore
    }
    throw new Error(message);
  }

  const data = (await res.json()) as ProjectsByIdsResponse;
  return (data?.projects ?? []).filter(Boolean);
}